import React, { useState } from 'react';
import { ShoppingBag, Check } from 'lucide-react';
import colors from '../theme/colors';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { toast } from '../hooks/use-toast';

const BuyHennaCone = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    quantity: '1',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    toast({
      title: "Inquiry Submitted!",
      description: "We'll contact you soon with pricing and delivery details.",
    });
    setFormData({ name: '', email: '', phone: '', quantity: '1', message: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const features = [
    '100% Organic & Chemical-Free',
    'Rich, Long-Lasting Stain',
    'Easy to Apply',
    'Fresh & Authentic',
    'Safe for Sensitive Skin',
    'Eco-Friendly Packaging'
  ];

  return (
    <div style={{ backgroundColor: colors.background }} className="min-h-screen">
      {/* Header Section */}
      <section style={{ background: `linear-gradient(135deg, ${colors.white} 0%, ${colors.background} 100%)` }} className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <ShoppingBag style={{ color: colors.highlight }} size={64} className="mx-auto mb-6" />
          <h1 style={{ color: colors.primary }} className="text-5xl md:text-6xl font-bold mb-6">Organic Henna Cones</h1>
          <p style={{ color: colors.text.medium }} className="text-xl max-w-3xl mx-auto leading-relaxed">
            Premium quality, 100% organic henna cones for beautiful, natural mehndi designs at home.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Product Info */}
          <div>
            <div style={{ backgroundColor: colors.white }} className="rounded-2xl p-8 shadow-lg mb-8">
              <h2 style={{ color: colors.primary }} className="text-3xl font-bold mb-6">Why Choose Our Henna Cones?</h2>
              <div className="space-y-4">
                {features.map((feature, idx) => (
                  <div key={idx} className="flex items-center space-x-3">
                    <div style={{ backgroundColor: colors.highlight }} className="rounded-full p-1.5">
                      <Check style={{ color: colors.white }} size={16} />
                    </div>
                    <span style={{ color: colors.text.medium }} className="text-base">{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            <div 
              style={{ 
                background: `linear-gradient(135deg, ${colors.secondary} 0%, ${colors.highlight} 100%)`,
                color: colors.white 
              }}
              className="rounded-2xl p-8"
            >
              <h3 className="text-2xl font-bold mb-4">Product Details</h3>
              <div className="space-y-3">
                <p className="text-base"><strong>Ingredients:</strong> 100% Natural Henna Powder</p>
                <p className="text-base"><strong>Shelf Life:</strong> 6 months from manufacturing</p>
                <p className="text-base"><strong>Storage:</strong> Keep refrigerated for best results</p>
                <p className="text-base"><strong>Stain Duration:</strong> Lasts 1-2 weeks</p>
              </div>
            </div>
          </div>

          {/* Inquiry Form */}
          <div>
            <div style={{ backgroundColor: colors.white }} className="rounded-2xl p-8 shadow-lg">
              <h2 style={{ color: colors.primary }} className="text-3xl font-bold mb-6">Place Your Order</h2>
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label style={{ color: colors.text.dark }} className="block text-sm font-semibold mb-2">Name *</label>
                  <Input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your full name"
                    className="w-full"
                    style={{ borderColor: colors.accent }}
                  />
                </div>

                <div>
                  <label style={{ color: colors.text.dark }} className="block text-sm font-semibold mb-2">Email *</label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                    className="w-full"
                    style={{ borderColor: colors.accent }}
                  />
                </div>

                <div>
                  <label style={{ color: colors.text.dark }} className="block text-sm font-semibold mb-2">Phone *</label>
                  <Input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="+91 98765 43210"
                    className="w-full"
                    style={{ borderColor: colors.accent }}
                  />
                </div>

                <div>
                  <label style={{ color: colors.text.dark }} className="block text-sm font-semibold mb-2">Quantity *</label>
                  <Input
                    type="number"
                    name="quantity"
                    value={formData.quantity}
                    onChange={handleChange}
                    required
                    min="1"
                    placeholder="Number of cones"
                    className="w-full"
                    style={{ borderColor: colors.accent }}
                  />
                </div>

                <div>
                  <label style={{ color: colors.text.dark }} className="block text-sm font-semibold mb-2">Additional Message</label>
                  <Textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Any special requirements or questions..."
                    className="w-full min-h-[100px]"
                    style={{ borderColor: colors.accent }}
                  />
                </div>

                <Button
                  type="submit"
                  style={{ backgroundColor: colors.highlight, color: colors.white }}
                  className="w-full py-6 text-lg font-semibold rounded-full transition-all duration-300 hover:opacity-90"
                >
                  Submit Inquiry
                </Button>
              </form>
              <p style={{ color: colors.text.medium }} className="text-sm mt-4 text-center">
                We'll contact you within 24 hours with pricing and delivery details
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BuyHennaCone;